module.exports = __webpack_public_path__ + "static/img/jidi1.83865f04.png";